interface TextCellProps {
  value: string | number | undefined;
}

export function TextCell({ value }: TextCellProps) {
  return (
    <td className="size-px whitespace-nowrap px-4 py-1">
      <span className="text-sm text-onsurface">{value}</span>
    </td>
  );
}
